import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KineticHeading, Reveal } from "@/components/site/Reveal";
import ProductCard from "@/components/site/ProductCard";

export default function Collection() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(["All", ...r.data.categories])).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = active === "All" ? {} : { category: active };
    api
      .get("/products", { params })
      .then((r) => setProducts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div data-testid="collection-page" className="pt-32 md:pt-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <p className="text-xs tracking-[0.4em] uppercase text-primary mb-6">The Collection</p>
        <KineticHeading
          className="font-serif font-light leading-[0.95] text-5xl sm:text-7xl lg:text-8xl"
          lines={["Every piece,", "a quiet statement."]}
        />

        {/* Filters */}
        <Reveal delay={0.2}>
          <div data-testid="category-filters" className="mt-14 flex flex-wrap gap-3 border-b border-border pb-8">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setActive(c)}
                className={`px-5 py-2 text-sm tracking-wide border transition-colors duration-400 ${
                  active === c
                    ? "bg-primary text-primary-foreground border-primary"
                    : "border-border text-foreground/70 hover:border-primary hover:text-primary"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </Reveal>

        {/* Grid */}
        <div className="mt-16 pb-8">
          {loading ? (
            <p className="text-muted-foreground py-20 text-center" data-testid="collection-loading">Loading the collection…</p>
          ) : products.length === 0 ? (
            <p className="text-muted-foreground py-20 text-center" data-testid="collection-empty">No pieces in this category yet.</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
              {products.map((p, i) => (
                <ProductCard key={p.id} product={p} index={i} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
